// Auto-generated by scripts/generate-blog-data.js — do not edit manually
import post_ai_agents_vs_agentic_ai from './generated/ai_agents_vs_agentic_ai';
import post_ai_behaves_like_humans_so_how_do_we_test_the_unexpected from './generated/ai_behaves_like_humans_so_how_do_we_test_the_unexpected';
import post_apis_power_modern_development_and_devops from './generated/apis_power_modern_development_and_devops';
import post_building_an_ai_ride_booking_assistant_with_gemini_tool_calling_gen_ui from './generated/building_an_ai_ride_booking_assistant_with_gemini_tool_calling_gen_ui';
import post_generative_ui from './generated/generative_ui';
import post_hotel_policy_rag_pipeline from './generated/hotel_policy_rag_pipeline';
import post_ollama from './generated/ollama';

const blogPosts = [
  post_ai_agents_vs_agentic_ai,
  post_ai_behaves_like_humans_so_how_do_we_test_the_unexpected,
  post_apis_power_modern_development_and_devops,
  post_building_an_ai_ride_booking_assistant_with_gemini_tool_calling_gen_ui,
  post_generative_ui,
  post_hotel_policy_rag_pipeline,
  post_ollama
];

export default blogPosts;
